<template>
    <div class="relative">
		<div class="fixed white" style="width: 100%;" id="tool-bar">
			<v-row style="width: 100%" align="center" justify="start" class="ma-0">
				<v-col cols="auto">
					<slot name="breadcrumbs" :item="true"></slot>
				</v-col>
                <v-spacer/>
                <v-col cols="auto">
                    <v-btn  
                        :to="{
                            name: 'materials-journals',
                            params: {
                                id: this.$route.query.invoiceId ? this.$route.query.invoiceId : null
                            }
                        }"
                        color="grey white--text"
                    >
                        <v-icon small class="me-1"> mdi-arrow-left-circle </v-icon>
                        {{ $t('buttons.back') }}
                    </v-btn>
                </v-col>
                <v-col cols="auto" v-if="$route.params.id">
                    <!-- export -->
                    <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn dark color="printingColor" class="px-2" v-on="on">
                                <span class="d-flex align-center">
                                    <v-icon color="white">mdi-export-variant</v-icon>
                                    <span style="font-size: 14px">
                                        {{$t('MaterialStatmentPage.export')}}
                                    </span>
                                </span>
                            </v-btn>
                        </template>

                        <bee-list>
                            <!-- pdf -->
                            <bee-list-item
                                context="statement"
                                :item="exportItems[0]"
                                dense
                                @click="exportAs('pdf')"
                            ></bee-list-item>
                            
                            <!-- excel -->
                            <bee-list-item
                                context="statement"
                                :item="exportItems[1]"
                                dense
                                @click="exportAs('excel')"
                            ></bee-list-item>
                        </bee-list>
                    </v-menu>
                </v-col>
			</v-row>
			<v-layout wrap class="d-flex flex-row my-border rounded-lg mx-3 mb-3 align-center">
                <v-col cols="auto" lg="2" class="d-flex flex-column">
                    <v-autocomplete 
                        v-model="warehouseId"
                        :items="(userTypePermission === userType.warehouseKeeper && multipleWarehouses) ? warehousesForWarehousekeepr : warehouses"
                        item-text="name"
                        item-value="id"
                        dense
                        outlined
                        :label="$t('inputs.warehouse')"
                        hide-details
                    />
                </v-col>
				<v-col cols="auto" lg="3" class="d-flex flex-column">
                    <bee-material-autocomplete 
                        :label="$t('MaterialStatmentPage.material-name-or-num')" 
                        context="statement"
                        color="primary" 
                        v-model="material_id" 
                        :items="materials.filter(c => c.warehouse_id === warehouseId)" 
                        :clearable="true"
                        :hide-details="true"
                        :action_name="actions.GET"
                        ref="BeeAutocomplete"
                        @keydown-enter-prevent="search()"
                        :with-balance="true"
                    ></bee-material-autocomplete>
                </v-col>
                <!-- start date -->
                <v-col sm="auto" lg="auto" cols="12" class="d-flex flex-column">
                    <bee-date-picker
                        context="statement"
                        :label="$t('MaterialStatmentPage.from-date')"
                        v-model="from_date"
                        :action-name="actions.GET"
                        :hide-details="true"
                        :disabled="false"
                        @keydown-enter-prevent="search()"
                    ></bee-date-picker>
                </v-col>
                <!-- end date -->
                <v-col sm="auto" lg="auto" cols="12" class="d-flex flex-column pl-lg-0">
                    <bee-date-picker
                        v-model="to_date"
                        :label="$t('MaterialStatmentPage.to-date')"
                        context="statement"
                        :action-name="actions.GET"
                        :hide-details="true"
                        :disabled="false"
                        @keydown-enter-prevent="search()"
                    ></bee-date-picker>
                </v-col>
                <v-spacer></v-spacer>
                <!-- update table -->
                <v-col lg="auto" sm='auto' cols="12" class="d-flex justify-end align-center">
                    <bee-btn
                        context="statement"
                        :action-name="actions.EDIT"
                        :content="$t('MaterialStatmentPage.refresh')"
                        :disabled="false"
                        outer-class="mt-0 me-3"
                        color="blueGray"
                        @click="search()"
                    ></bee-btn>
                    <v-icon small color="grey" @click="cancel()" :loading="loading">fa-times-circle</v-icon>
                </v-col>
            </v-layout>
        </div>
        <!-- table -->
        <div class="ma-auto absolute" id="main" style="width: 100%; height: auto">
        <v-card flat>
            <v-card-text class="pt-0 px-3">
                <bee-simple-table
                    :fixed-header="true"
                    context="statement"
                    :action-name="actions.GET"
                    ref="table" 
                    :with-color="false"
                    :zebra="true"
                    empty-state="none"
                    :hide-footer="true"
                    :configs="configs"
                    :headers="headers"
                    :items="items || []"
                    :show-menu-actions="true"
				    :right-click-menu-items="[{name: 'redirect', disabled: false, text:$t('MaterialStatmentPage.go-to-the-journal-entry'), action_name: actions.GET}]"
                    @redirect="redirectToJournal($event)"
                ></bee-simple-table>
            </v-card-text>
        </v-card>
        </div>
        <!-- fixed footer -->
        <v-bottom-navigation id="footer" app class="px-3" horizontal background-color="#E1E2E4">
            <v-row align="center" justify="center" justify-lg="start">
                <v-spacer></v-spacer>
                <!-- balance -->
                <v-col cols="auto" lg="auto" class="ma-0 pa-0 d-flex">
                    <bee-outlined-header-info
                        border-color="transparent"
                        :head="$t('MaterialStatmentPage.final-balance')"
                        :column="false"
                    >
                        <template  v-slot:content="{}">
                            <bee-material-amount-label
                                empty-state="_"
                                :value="summary.balance"
                            ></bee-material-amount-label>
                        </template>
                    </bee-outlined-header-info>
                </v-col>
                <!-- sum_input_quantity -->
                <v-col cols="auto" lg="auto" class="ma-0 pa-0 d-flex">
                    <bee-outlined-header-info
                        border-color="transparent"
                        :head="$t('MaterialStatmentPage.total-incoming-quantity')"
                        :column="false"
                    >
                        <template  v-slot:content="{}">
                            <bee-quantity-label
                                color="green"
                                empty-state="_"
                                :value="summary.sum_input_quantity"
                            ></bee-quantity-label>
                        </template>
                    </bee-outlined-header-info>
                </v-col>
                <!-- sum_output_quantity -->
                <v-col cols="auto" lg="auto" class="ma-0 pa-0 d-flex">
                    <bee-outlined-header-info
                        border-color="transparent"
                        :head="$t('MaterialStatmentPage.total-outcoming-quantity')"
                        :column="false"
                    >
                        <template  v-slot:content="{}">
                            <bee-quantity-label
                                color="red"
                                empty-state="_"
                                :value="summary.sum_output_quantity"
                            ></bee-quantity-label>
                        </template>
                    </bee-outlined-header-info>
                </v-col>
            </v-row>
        </v-bottom-navigation>
    </div>
</template>

<script>
import actions from "../../../permissions/actions-names.js"
import store from "../../../store/index"
import { mapState } from 'vuex';
import ls from '../../../settings/localStorageExtension';
import { invoiceType, userType } from '@/helpers/enums';
import { multipleWarehouses } from '@/configs/global'
export default {
    data: () => ({
        material_id: null,
        from_date: null,
        to_date: null,
        loading:false,
        actions,
        default_summary:{
            balance: { quantity: null, unit_size_id: null },
            sum_input_quantity: { quantity: null, unit_size_id: null },
            sum_output_quantity: { quantity: null, unit_size_id: null },
        },
        warehouseId: null,
        userType,
        multipleWarehouses
    }),

    computed:{
        ...mapState("statements", ["material_statement"]),
        ...mapState("configs", ["configs"]),
        ...mapState("invoices", ["simplified_buy_invoices"]),
        ...mapState("invoices", ["simplified_sale_invoices"]),
        ...mapState("materials", ["materials"]),
        ...mapState("materialsJournals", ["materials_journals"]),
        ...mapState({
            warehouses: state => state.warehouses.warehouses,
            userTypePermission: state => state.permissions.user_type,
            warehousesForWarehousekeepr: state => state.configs.configs.warehouse
        }),
        exportItems() {
            return [
                {
                    text: this.$t('MaterialStatmentPage.print-material-statement'),
                    icon: 'mdi-printer',
                    context: 'statement',
                    action_name: actions.EXPORT_AS_PDF
                },
                {
                    text: this.$t('MaterialStatmentPage.export-as-excel'),
                    icon: 'mdi-microsoft-excel',
                    context: 'statement',
                    action_name: actions.EXPORT_AS_PDF
                },
            ]
        },
        summary(){
            return this.material_statement?.material_report_summary ? this.material_statement?.material_report_summary : this.default_summary
        },
        invoices(){
            return [{ id: null, no: null}].concat(this.simplified_sale_invoices, this.simplified_buy_invoices)
        },
        journals(){
            return [{ id: null, no: null }].concat(this.materials_journals)
        },

        headers(){
            return [
            { 
                text: this.$t('MaterialStatmentPage.headers.balance'),
                value: 'balance',
                type: 'numeric',
                width: "10%" 
            },
            { 
                text: this.$t('MaterialStatmentPage.headers.income-quantity'),
                value: 'in_quantity',
                type: 'numeric',
                width: "10%" 
            },
            { 
                text: this.$t('MaterialStatmentPage.headers.outcome-quantity'),
                value: 'out_quantity',
                type: 'numeric',
                width: "10%" 
            },
            { 
                text: this.$t('MaterialStatmentPage.headers.count'),
                value: 'count',
                type: 'numeric',
                width: "5%" 
            },
            { 
                text: this.$t('MaterialStatmentPage.headers.note'),
                value: 'notes',
                type: 'string',
                width: "15%" 
            },
            { 
                text: this.$t('MaterialStatmentPage.headers.date'),
                value: 'date',
                type: 'date',
                width: "8%" 
            },
            { 
                text: this.$t('MaterialStatmentPage.headers.price'),
                value: 'price',
                type: 'money',
                width: "10%" 
            },
            { 
                text: this.$t('MaterialStatmentPage.headers.document-no'),
                value: 'doc_no',
                type: 'string',
                width: "5%" 
            },
            { 
                text: this.$t('MaterialStatmentPage.headers.materials-journal-balance'),
                value: ' materials_journal_id',
                type: 'autocomplete', 
                width: this.$emerald.ifLang('es', '15%','7%'),
                settings: { itemText: 'no', itemValue: 'id', items: this.journals }
            },
            { 
                text: this.$t('MaterialStatmentPage.headers.invoice-balance'),
                value: ' invoice_id',
                type: 'autocomplete',
                width: this.$emerald.ifLang('es', '15%','5%'),
                settings: { itemText: 'no', itemValue: 'id', items: this.invoices }
            },
            { 
                text: this.$t('MaterialStatmentPage.headers.sequence'),
                value: 'material_entry_no',
                type: 'string',
                width: "5%"
            },
            { 
                text: this.$t('MaterialStatmentPage.headers.account'),
                value: 'account_id',
                type: 'accounts-autocomplete',
                width: "10%",
                settings: { itemValue: 'id', items: this.configs.accounts }
            },
        ]},
        items(){
		return this.material_statement?.material_report_rows?.map(obj=> ({
                    ...obj, 
                    in_quantity: obj.type == 1 ? obj.quantity?.quantity : null,
                    out_quantity: obj.type == 2 ? obj.quantity?.quantity : null
                })) 
        },
    },
    mounted(){
        window.observer.observe(document.querySelector("#tool-bar"))
        window.observer.observe(document.querySelector("#footer"))
        this.$store.dispatch('warehouses/fetchAll').then(() => {
            this.warehouseId = this.warehouses.find(c => c.is_default === true)?.id
        })
        this.setFocus()
        this.reSetDates()
        if(this.$route.params.id)
            this.material_id = this.$route.params.id
        this.search()
    },
    beforeDestroy(){
        store.dispatch("statements/clear")
    },
    methods:{
        search(){
		if(this.material_id)
			{ 
				this.loading = true
				store.dispatch("statements/fetchMaterialStatement", { 
					material_id: this.material_id, 
					from_date: this.from_date, 
					to_date: this.to_date, 
				})
				.then(()=>{
					this.$router.push({ name: "material-statment", params: { id: this.material_id }}).catch(()=>{})
				}).finally(()=>{ 
					this.loading = false
				})
			}
        },
        cancel() {
            this.reSet()
            this.$router.push({ name: "materials-statement" }).catch(()=>{})
        },
        reSet(){
            this.reSetDates()
            this.material_id = null
            this.loading = false
            this.setFocus();
            store.dispatch("statements/clear")
        },
        reSetDates(){
            this.from_date = new Date().toISOString().substr(0, 10)
            this.to_date = new Date().toISOString().substr(0, 10)
            if(this.configs)
                this.from_date = this.configs.financial_file.start_date
        },
        setFocus(){
            this.$refs['BeeAutocomplete'].$refs.BeeMaterialAutocomplete.$refs.BeeAutocomplete.focus()
        },
        redirectToJournal(entry){
            let routeData = this.$router.resolve({ name: 'materials-journal', params: { id: entry.materials_journal_id }, query: { entryId: entry.id }});
            window.open(routeData.href, '_blank');
        },
        exportAs(type){
            this.$store.dispatch('reports/MaterialStatementReport', {
                type,
                financialFileId: this.configs.financial_file.id,
                userId: ls.getLocalUser().id,
                materialId: this.material_id,
                FromDate: this.from_date,
                ToDate: this.to_date
            })
        }
    },

    async beforeRouteEnter(to, from, next) {
        let promises = [store.dispatch("materials/fetchAll")]

        let configs = JSON.parse(JSON.stringify(store.state.configs.configs))
        if(Object.keys(configs).length == 0)
            promises.push(store.dispatch("configs/fetchAll"))
       
       let buy_invoices = JSON.parse(JSON.stringify(store.state.invoices.simplified_buy_invoices))
        if(buy_invoices.length == 0)
            promises.push(store.dispatch("invoices/fetchAll", invoiceType.buy))

        let sale_invoices = JSON.parse(JSON.stringify(store.state.invoices.simplified_sale_invoices))
        if(sale_invoices.length == 0)
            promises.push(store.dispatch("invoices/fetchAll", invoiceType.sale))

        if(promises.length)
            await Promise.all(promises).then(()=>{
                let configs = JSON.parse(JSON.stringify(store.state.configs.configs))
                store.dispatch("materialsJournals/fetchAll", { fromDate: configs.financial_file.start_date, toDate: new Date().toISOString().substr(0, 10) })
            })

        next();
    },
}
</script>

<style scoped>
.border {
    border: 1px solid #f1f1f1;
    border-radius: 8px;
}
.rounded-right{
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
}
.rounded-bottom{
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}
</style>